import { motion } from "framer-motion";
import { MaskedLines } from "./Reveal";

export const ChapterShell = ({ n, id, era, title, quote, children, dark = false, className = "" }) => (
  <section
    data-chapter={n}
    id={id}
    data-testid={id}
    className={`relative overflow-hidden py-24 md:py-36 ${dark ? "spotlight-dark bg-[#0A192F] text-white" : "bg-transparent"} ${className}`}
  >
    <div
      aria-hidden
      className={`pointer-events-none absolute -top-14 right-0 select-none font-display text-[26vw] font-black leading-none tracking-tighter ${
        dark ? "text-white/[0.045]" : "text-[#0A192F]/[0.045]"
      }`}
    >
      {n}
    </div>

    <div className="relative mx-auto max-w-7xl px-6 md:px-10">
      <motion.p
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className={`text-xs font-bold uppercase tracking-[0.32em] ${dark ? "text-[#00E5FF]" : "text-[#00BFA5]"}`}
      >
        Chapter {n} · {era}
      </motion.p>

      <h2 className={`mt-5 font-display text-4xl font-black tracking-tight md:text-6xl ${dark ? "text-white" : "text-[#0A192F]"}`}>
        <MaskedLines lines={[title]} />
      </h2>

      {quote && (
        <motion.blockquote
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.25 }}
          className={`mt-6 max-w-2xl border-l-2 pl-6 text-base italic leading-relaxed md:text-lg ${
            dark ? "border-[#00E5FF] text-white/70" : "border-[#00BFA5] text-[#4A5568]"
          }`}
        >
          {quote}
        </motion.blockquote>
      )}

      <div className="mt-14 md:mt-20">{children}</div>
    </div>
  </section>
);
